import camelcaseKeys from 'camelcase-keys';

export function toCamelCase(response: any) {
  return camelcaseKeys(response, { deep: true });
}
